// export const FlashingArrow = ({ targetRef, direction = "top" }) => {
//   const [style, setStyle] = useState({});

//   useEffect(() => {
//     const updatePosition = () => {
//       if (targetRef.current) {
//         const rect = targetRef.current.getBoundingClientRect();
//         setStyle({
//           position: "absolute",
//           top: rect.top + window.scrollY - 30,
//           left: rect.left + rect.width / 2,
//           transform: "translateX(-50%)",
//           zIndex: 1000,
//           animation: "flash 1s infinite",
//         });
//       }
//     };

//     updatePosition();
//     window.addEventListener("resize", updatePosition);
//     return () => window.removeEventListener("resize", updatePosition);
//   }, [targetRef]);

//   return (
//     <div style={style}>
//       <img src="/arrow-up.gif" alt="arrow" />
//     </div>
//   );
// };


import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% { opacity: 0.2; transform: translateY(0); }
  50% { opacity: 1; transform: translateY(-5px); }
  100% { opacity: 0.2; transform: translateY(0); }
`;

export const FlashingArrow = styled.div`
  position: absolute;
  top: ${(props) => props.t || '0'};
  left: ${(props) => props.l || '0'};
  bottom: ${(props) => props.b || '0'};
  font-size: 2rem;
  color: orange;
  z-index: 9999;
  animation: ${pulse} 1s infinite;
  pointer-events: none;
`;

export const FlashingArrowConnect = styled.div`
  position: absolute;
  top: ${(props) => props.t || '0'};
  left: ${(props) => props.l || '0'};
  bottom: ${(props) => props.b || '0'};
  right: ${(props) => props.r || '0'};
  font-size: 2rem;
  color: orange;
  z-index: 1;
  animation: ${pulse} 1s infinite;
  pointer-events: none;

  &::after {
    content: "👈";
  }
    
  @media (max-width: 500px) {
    top:  -15px;
    left: 0;
    &::after {
      content: "👇";
    }
  }
`;